import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function OpenInBrowserIcon(props: IconProps) {
    return <Icon {...props} iconKey={"open_in_browser"}/>
}
